import {isEmpty, cloneDeep} from 'lodash'
import { getMetaCollectionList, getMetaDossierList, updateFavourite, followCollection } from '@/libs/api/api'
import {errorHandler, logout, message, getCatalogId, loader} from '@/libs/helper'
import constants from '@/libs/constant/constants'
export default {
    name: 'CollectionList',
    components: {
        List: () => import('@/components/pages/InformationPortal/ProfilePage/Collections/List/List.vue')
    },
    props: {
        isDossier: {
            type: Boolean,
            default: false
        },
        routeToArticlePage: {
            type: Function,
            default: () => {}
        },
        module: {
            type: String,
            default: constants.ORGANISATIONS.TEAM
        }
    },
    mounted () {
        this.fetchList()
    },
    data() {
        return {
            isEmpty,
            isArticles: false,
            collectionList: [],
            collectionListResult: {},
            collectionListToDisplay: [],
            searchValue: '',
            skip: 0,
            limit: 30,
            order: 'desc',
            sort: 'createdAt',
            isFetching: false,
            currentPage: 1
        }
    },
    methods: {
        /**
         * to fetch the collections
         * @param {*} body 
         * @param {*} params 
         */
        fetchCollection (body, params) {
            this.isFetching = true
            // api call
            getMetaCollectionList(body, params).then(response => {
                this.collectionList = cloneDeep(response.items || [])
                this.collectionListToDisplay = (response.items || [])
                this.collectionListResult = (response || {})
                this.isFetching = false
            }).catch((error) => {
                this.isFetching = false
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
            })
        },

        /**
         * to fetch dossiers
         */
        fetchDossier (body, params) {
            this.isFetching = true
            // api call
            getMetaDossierList(body, params).then(response => {
                this.collectionList = cloneDeep(response.items || [])
                this.collectionListToDisplay = (response.items || [])
                this.collectionListResult = (response || {})
                this.isFetching = false
            }).catch((error) => {
                this.isFetching = false
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
            })
        },

        /**
         * to get body based on conditions
         */
        fetchBody () {
            let body = {
                entity_type: this.module
            }
            switch (this.module) {
                case constants.ORGANISATIONS.ORGANISATION:
                    body.entity_id = this.$route.params.id 
                break
                default:
                    body.entity_id = this.$route.params.tid 
                break
            }
            return body
        },

        /**
         * to clearFields
         */
        clearFields () {
            this.skip = 0
            this.currentPage = 1
        },

        /**
         * to fetch the list WRT body and params
         */
        async fetchList () {
            let body = await this.fetchBody()
            let params = {
                skip: this.skip,
                limit: this.limit,
                order: this.order,
                sort: this.sort
            }
            if (this.isDossier) this.fetchDossier(body, params)
            else this.fetchCollection(body, params)
        },

        /**
         * to change the pages 
         * @param {*} currentPage 
         */
        changePage (currentPage) {
            this.currentPage = currentPage
            // setting the skip as per the current page
            this.skip = (currentPage - 1) * this.limit
            // call for fetching the articles
            this.fetchList()
        },

        /**
         * route to article pages
         */
        // eslint-disable-next-line
        routeToCollectionDetailPage (list) {
            if (this.isTeams) {
                this.$router.push({name: ''})
            }
        },

        /**
         * follow/unfollow collection and updte the count
         * @param {*} list Object
         */
        followCollectionList (list) {
            loader(this, true)
            // body for api
            let body = {
                entity_type: this.isDossier ? constants.LIST.DOSSIER : constants.LIST.COLLECTION,
                entity_id: list.id || list._id,
                catalog_id: getCatalogId()
            }
            // api call
            followCollection(body, list.is_following ? 'unfollow' : 'follow').then(async() => {
                this.collectionList = this.collectionList.map(collection => {
                    if (collection.id === list.id || collection._id === list._id) {
                        collection.is_following = !collection.is_following
                    }
                    return collection
                })
                this.collectionListToDisplay = cloneDeep(this.collectionList)
                message(this, constants.messageType.SUCCESS, `${list.is_following ? ('Unfollowed Successfully') : ('Followed Successfully')}`)
                loader(this, false)
            }).catch(error => {
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                loader(this, false)
            })
        },
        /**
         * to get the favorite for collection/dossier
         */
        getCollectionFavorite (list) {
            // to check for collection/dossier
            if (list && list.favorites && new Set(list.favorites).has(this.$store.getters.getUserInformation.id)) return true
            // to check for detail page(A/P/P)
            else return false
        },
        /**
         * create/delete favorite for collection and dossier
         */
        async setCollectionFavorite (list) {
            try {
                loader(this, true)
                // body for api
                let isRemove = this.getCollectionFavorite(list)
                let body = {
                    entity_type: this.isDossier ? constants.LIST.DOSSIER : constants.LIST.COLLECTION,
                    entity_id: list.id || list._id
                }
                // api call
                let response = await updateFavourite(body, isRemove ? 'remove-favorite' : 'favorite')
                list['favorites'] = response.result.favorites || []
                this.updateCollectionFavorite(list)
                message(this, constants.messageType.SUCCESS, !isRemove ? 'marked_favorite' : 'removed_favorite')
                loader(this, false)
            } catch (error) {
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                loader(this, false)
            }
        },
        /**
         * to update the listing
         * @param {*} list 
         */
        updateCollectionFavorite (list) {
            let collectionListToDisplay = cloneDeep(this.collectionListToDisplay)
            this.collectionListToDisplay = collectionListToDisplay.map(collection => {
                if (collection.id === list.id) collection.favorites = list.favorites
                return collection
            })
        }
    },
}